export const AB_TESTS = {
  RETRIEVE_OFFER: 'CARQATARRETRIEVEOFFER112024',
  PREFILL: 'CARQATARPREFILLFLOW2025',
  CORE_INTEGRATION: 'CARQATARCOREINTEGRATION',
  ODLITE: 'CARQATARODLITE',
} as const;

export type ABTestKey = keyof typeof AB_TESTS;
export type ABTestValue = (typeof AB_TESTS)[ABTestKey];

export const AB_GROUPS = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
} as const;

export type ABGroupKey = keyof typeof AB_GROUPS;
export type ABGroupValue = (typeof AB_GROUPS)[ABGroupKey];

export interface ABTests {
  AB_TESTS: typeof AB_TESTS;
  AB_GROUPS: typeof AB_GROUPS;
}
